<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    :validations="validations.nome"
                    label="Nome"
                    uppercase
                    v-model="model.nome"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.cnpj"
                    label="CNPJ"
                    v-mask="mask.cnpj"
                    v-model="model.cnpj"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-select
                    :options="form.conectasusFabricantes"
                    label="Fabricante (ConectaSUS)"
                    show-default-option
                    text-field="descricao"
                    v-model="model.conectasusFabricanteId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, mask, repository, stringCase, unmask} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                cnpj: {
                    min_max_without_mask: 14,
                    cnpj: true,
                },
            }
        },
    },
    created() {
        this.repositories = {
            fabricante: this.getConectaSusRepository('webService.almoxarifado.cliente.fabricante'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            if (this.id) {
                this.repositories.fabricante.edit(this.id)
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            } else {
                this.repositories.fabricante.create()
                    .then(response => {
                        this.form = Object.assign(response.data.form)
                        this.model = Object.assign(response.data.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        conectasusFabricanteId: this.model.conectasusFabricanteId,
                        nome: this.model.nome,
                        cnpj: this.model.cnpj ? this.unMaskCnpj(this.model.cnpj) : null,
                    }

                    if (this.id) {
                        this.repositories.fabricante.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.fabricante.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, mask, repository, stringCase, unmask],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>